import { ToolbarItem } from './ToolbarItem'
import { ToolbarSection } from './ToolbarSection'

export type PagebuilderSpaceItemType = {
  spaceTop?: 'sm' | 'md' | 'lg' | 'none'
  spaceBottom?: 'sm' | 'md' | 'lg' | 'none'
}

export const layoutDefaultProps = (space = undefined) => ({
  ...(typeof space !== 'undefined'
    ? {
        spaceTop: space,
        spaceBottom: space,
      }
    : {}),
})

export const layoutItemParams: (props?: any) => PagebuilderSpaceItemType = (props) => ({
  spaceTop: props.spaceTop,
  spaceBottom: props.spaceBottom,
})

const LayoutToolbarSection = ({ defaultProps, initOpen = false }) => {
  const spaceOpts = [
    { label: 'Nessuno', value: 'none' },
    { label: 'Piccolo', value: 'sm' },
    { label: 'Medio', value: 'md' },
    { label: 'Grande', value: 'lg' },
  ]

  return (
    <ToolbarSection title="Layout" initOpen={initOpen}>
      {'spaceTop' in defaultProps && (
        <ToolbarItem
          propKey="block"
          propSubKey="spaceTop"
          type="select"
          options={spaceOpts}
          label="Spazio sopra"
          defaultValue={defaultProps['spaceTop']}
        />
      )}
      {'spaceBottom' in defaultProps && (
        <ToolbarItem
          propKey="block"
          propSubKey="spaceBottom"
          type="select"
          options={spaceOpts}
          label="Spazio sotto"
          defaultValue={defaultProps['spaceBottom']}
        />
      )}
    </ToolbarSection>
  )
}

export default LayoutToolbarSection
